<div class="profile--user-data w-full">
  <img class="profile--user-avatar" [src]="user().avatar" />
  <div class="profile--user-extra flex items-center gap-4">
    <span class="profile--user-name typography-small-title font-bold">{{
      user().name
    }}</span>
    <app-user-level [level]="user().level"></app-user-level>
    <a
      class="button h-20 button--style-gray-08 padding-x-4 rounded-4"
      href="https://steamcommunity.com/profiles/{{ user().steamid }}"
      target="_blank"
    >
      <svg-icon
        class="s-16 flex items-center justify-center"
        src="assets/icons/ui/steam.svg"
        [svgStyle]="{ width: '16px', height: '12px' }"
      ></svg-icon>
    </a>
    @if (showCopyFn()) {
    <button
      class="copy-button button--style-primary button h-20 rounded-4 padding-x-4"
      style="flex-shrink: 0; white-space: nowrap"
      (click)="clipboardService.copy(user().steamid, 'SteamID copied')"
    >
      <span class="typography-small" style="font-size: 10px">
        Copy SteamID
      </span>
    </button>
    } @if (showLogout()) {
    <button
      class="copy-button button--style-red button h-20 rounded-4 padding-x-8"
      style="flex-shrink: 0; white-space: nowrap; gap: 4px"
      (click)="logoutFn.emit()"
    >
      <svg-icon
        class="s-16 flex items-center justify-center"
        src="assets/icons/features/logout.svg"
        [svgStyle]="{ width: '16px', height: '12px' }"
      ></svg-icon>
      <span class="typography-small" style="font-size: 10px">Log out</span>
    </button>
    }
  </div>
  <div class="profile--user-joined">{{date() ? `Joined ${date()}` : ''}}</div>
</div>
